import addLog from "../utils/addLog";

export interface AccountInfo {
  isLiveOnlineVendor: boolean;
}

const getLolAccount = async (authToken: string) => {
  let response = null;
  let data: AccountInfo = null;
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    Authorization: `bearer ${authToken}`,
  };

  const url = new URL(`${process.env.API_URL}/api/customer/lolaccount`);

  try {
    addLog({
      message: {
        route: `GET ${url}`,
        headers,
      },
      severity: "info",
    });

    response = await fetch(url, {
      method: "GET",
      headers,
    });

    data = await response.json();
  } catch (error) {
    addLog({
      message: {
        route: `GET ${url}`,
        statusCode: response.status,
        message: response.statusText,
      },
      error,
      severity: "error",
    });
    return null;
  }

  return data;
};

export default getLolAccount;
